module.exports = __webpack_public_path__ + "img/zhihi2.4c8db7a8.png";